<template>
    <el-form
        :model="value"
        :rules="rules"
        ref="form"
        label-position="top"
        class="login-form-inner"
        :class="formClass"
        @submit.native.prevent="$emit('submit')"
    >
        <header v-if="showHeader" class="login-form-inner__header">
            <p v-if="eyebrow" class="login-form-inner__eyebrow">{{ eyebrow }}</p>
            <h2 class="login-form-inner__title">{{ title }}</h2>
            <p class="login-form-inner__hint">{{ hint }}</p>
        </header>

        <el-form-item label="账号" prop="account">
            <el-input
                type="text"
                v-model="value.account"
                auto-complete="username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                @keyup.enter.native="$emit('submit')"
            ></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="checkPass">
            <el-input
                v-model="value.checkPass"
                auto-complete="current-password"
                show-password
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                @focus.native="$emit('pwd-focus')"
                @blur.native="$emit('pwd-blur')"
                @keyup.enter.native="$emit('submit')"
            ></el-input>
        </el-form-item>

        <el-form-item class="login-form-inner__action">
            <el-button
                type="primary"
                class="login-form-inner__submit"
                @click.native.prevent="$emit('submit')"
                :loading="logining"
                :disabled="logining"
            >
                {{ loginStr }}
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
/**
 * 登录表单共用块，供多套皮肤复用。创建于 2026-03-29
 */
export default {
    name: 'LoginFormInner',
    props: {
        value: { type: Object, required: true },
        rules: { type: Object, required: true },
        loginStr: { type: String, default: '登录' },
        logining: { type: Boolean, default: false },
        title: { type: String, default: '账号登录' },
        hint: { type: String, default: '请使用管理员账号进入后台' },
        eyebrow: { type: String, default: '' },
        showHeader: { type: Boolean, default: true },
        formClass: { type: String, default: '' },
    },
    methods: {
        /**
         * 对外暴露校验。最后更新：2026-03-29
         */
        validate(callback) {
            this.$refs.form.validate(callback);
        },
        resetFields() {
            this.$refs.form.resetFields();
        },
    },
};
</script>

<style scoped>
.login-form-inner__header {
    margin-bottom: 28px;
}

.login-form-inner__eyebrow {
    margin: 0 0 8px;
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #94a3b8;
    font-weight: 600;
}

.login-form-inner__title {
    margin: 0 0 8px;
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
}

.login-form-inner__hint {
    margin: 0;
    font-size: 13px;
    color: #64748b;
}

.login-form-inner >>> .el-form-item {
    margin-bottom: 20px;
}

.login-form-inner >>> .el-form-item__label {
    padding: 0 0 6px;
    line-height: 1.2;
    color: #334155;
    font-weight: 500;
}

.login-form-inner >>> .el-input__inner {
    height: 46px;
    line-height: 46px;
    border-radius: 12px;
    border-color: #dbe3ee;
    background: #f1f5f9;
    transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.login-form-inner >>> .el-input__inner:focus {
    border-color: #2563eb;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);
}

.login-form-inner >>> .el-input__prefix {
    left: 8px;
    color: #94a3b8;
}

.login-form-inner >>> .el-input--prefix .el-input__inner {
    padding-left: 36px;
}

.login-form-inner__action {
    margin-top: 10px;
    margin-bottom: 0 !important;
}

.login-form-inner__submit {
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 55%, #1d4ed8 100%);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.08em;
    cursor: pointer;
    box-shadow: 0 12px 28px rgba(37, 99, 235, 0.28);
}

.login-form-inner__submit:hover,
.login-form-inner__submit:focus {
    filter: brightness(1.04);
}

.login-form-inner >>> .el-button.is-disabled,
.login-form-inner >>> .el-button.is-disabled:hover {
    background: #93c5fd;
}
</style>
